export const text = {
  metaTitle: "Accessibility",
  heading: "Accessibility",
  subHeading: "Accessibility",
};
